import { useRef, useState } from "react";

const useFormValidation = (initialValues, validationSchema) => {
  const [errors, setErrors] = useState({});
  const errorsRef = useRef({});

  const validate = async (values) => {
    try {
      await validationSchema.validate(values, { abortEarly: false });
      errorsRef.current = {};
      setErrors({});
      return {};
    } catch (validationErrors) {
      const newErrors = validationErrors.inner.reduce((acc, err) => {
        acc[err.path] = err.message;
        return acc;
      }, {});
      errorsRef.current = newErrors;
      console.log("newErrors", newErrors);
      setErrors(newErrors);
      return newErrors;
    }
  };

  const validateField = async (name, value) => {
    try {
      await validationSchema.validateAt(name, { [name]: value });
      if (errorsRef.current[name]) {
        delete errorsRef.current[name];
        setErrors((prev) => ({ ...prev, [name]: undefined }));
      }
    } catch (err) {
      if (errorsRef.current[name] !== err.message) {
        errorsRef.current[name] = err.message;
        setErrors((prev) => ({ ...prev, [name]: err.message }));
      }
    }
  };

  return { errors, validate, validateField, setErrors};
};

export default useFormValidation;
